import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ButtonStack from 'components/item/ButtonStack';
import EditorBreadcrumbs from 'components/editor/EditorBreadcrumbs';
import type { EditorBreadcrumbsProps } from 'components/editor/EditorBreadcrumbs';

const EditLayout = ({
  title,
  buttonStack,
  children,
  breadcrumbTitle,
  breadcrumbParentItems,
  wrapActions = false,
}: {
  title: string;
  buttonStack: ReactNode;
  children: ReactNode;
  /** When set, shows list → title breadcrumbs above the scroll area. */
  breadcrumbTitle?: string;
  breadcrumbParentItems?: EditorBreadcrumbsProps['parentItems'];
  wrapActions?: boolean;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}
  >
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {breadcrumbTitle ? (
      <EditorBreadcrumbs currentLabel={breadcrumbTitle} parentItems={breadcrumbParentItems} />
    ) : null}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: wrapActions ? 'auto' : '100%',
        ...(wrapActions ? { minHeight: 0 } : {}),
      }}
    >
      <Box sx={{ flex: '1', overflowY: 'auto' }}>
        {children}
      </Box>
      <ButtonStack wrap={wrapActions}>
        {buttonStack}
      </ButtonStack>
    </Box>
  </Box>
);

export default EditLayout;
